import React from "react";
import _ from "lodash";
import "./styles/alert-box.css";
import TickIcon from "./TickIcon";
import { PageConfiguration } from "./index";

const PublishConfirmationAlert = ({
  landingPageURL,
  pageConfiguration,
  closeAlert
}: {
  landingPageURL: string;
  pageConfiguration: PageConfiguration;
  closeAlert: () => void;
}) => {
  return (
    <div>
      <div id="alert-box-dialog" className="modal fade in" role="dialog">
        <div className="modal-dialog alert-box-dialog-content">
          <div className="alert-box-content-div">
            <div className="alert-box-icon-div">
              <TickIcon color={pageConfiguration.primaryColor} />
            </div>
            <p className="alert-box-header">Your changes have been published</p>
            <a
              className="alert-box-btn btn btn-round btn-primary"
              href={landingPageURL}
              target="_blank"
              style={{ backgroundColor: pageConfiguration.primaryColor }}
            >
              {" "}
              Take a look{" "}
            </a>
          </div>
          <button className="alert-box-cancel-btn" onClick={closeAlert}>
            {" "}
            Close
          </button>
        </div>
      </div>{" "}
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default PublishConfirmationAlert;
